import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function ScottsdalePage() {
  return <LocationPageTemplate city="Scottsdale" cityShort="Scottsdale" slug="scottsdale" data-id="element-1020" />;
}